import { dateAndSearchBuilder, LIST_PAGE_SIZE } from 'modules/common';

export default function queryBuilder(filter) {
  let variables = {
    page: filter.page || 1,
    limit: LIST_PAGE_SIZE,
    type: filter.type,
  };

  variables = dateAndSearchBuilder({
    variables,
    search: filter.search,
    dateRangeStart: filter.dateRangeStart,
    dateRangeEnd: filter.dateRangeEnd,
  });

  return variables;
}
